import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

import HealingWithout   from '../assets/images/HealingWithout.png';
import Healingabot   from '../assets/images/Healingabot.png';
import RegenerativeMedicine   from '../assets/images/RegenerativeMedicine.png';
import mainSportsOrthopaedics   from '../assets/images/mainSportsOrthopaedics.png';
import PhysiotherapyRehab   from '../assets/images/PhysiotherapyRehab.png';
import GeethaBhargavi   from '../assets/images/GeethaBhargavi.jpeg';
import SadhanPalakuri   from '../assets/images/SadhanPalakuri.jpeg';
import ModernFacilities   from '../assets/images/ModernFacilities.png';
import AdvancedTreatment   from '../assets/images/AdvancedTreatment.png';
import PhysioArea   from '../assets/images/PhysioArea.png';


export default function About() {
  return (
    <div>

      {/* ── HERO ── */}
      <section className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="sep">›</span>
            <span>About Us</span>
          </div>
          <h1>About TheOrthomed</h1>
          <p>Hyderabad's advanced center for regenerative orthopaedic medicine — where cutting-edge science meets compassionate care.</p>
        </div>
      </section>

      {/* ── MISSION ── */}
      <section className="section" style={{ background: '#F8FAFC' }}>
        <div className="container">
          <div className="about-mission-grid">

            {/* Text */}
            <div>
              <div className="tag-line"><span>Our Mission</span></div>
              <h2 className="sec-title">
                Healing Without Surgery —<br />
                <span className="acc">Wherever Possible</span>
              </h2>
              <p className="abt-para">
                At TheOrthomed, we believe that the body has an extraordinary capacity to heal
                itself when given the right biological tools and support. Our mission is to harness
                that power through regenerative medicine — avoiding surgery when possible, and
                accelerating recovery when surgery is necessary.
              </p>
              <p className="abt-para" style={{ marginBottom: 32 }}>
                Founded by two fellowship-trained specialists — Dr. Geetha Bhargavi in pain
                medicine and Dr. Sadhan Palakuri in sports orthopaedics — TheOrthomed was built
                on a single belief: every patient deserves the most advanced, least invasive
                treatment available.
              </p>
              <div className="mission-values">
                <div className="mission-value">
                  <span className="mission-value-icon">🎯</span>
                  <span className="mission-value-label">Precision</span>
                </div>
                <div className="mission-value">
                  <span className="mission-value-icon">🧬</span>
                  <span className="mission-value-label">Innovation</span>
                </div>
                <div className="mission-value">
                  <span className="mission-value-icon">🤝</span>
                  <span className="mission-value-label">Compassion</span>
                </div>
                <div className="mission-value">
                  <span className="mission-value-icon">⚡</span>
                  <span className="mission-value-label">Excellence</span>
                </div>
              </div>
            </div>

            {/* Images */}
            <div className="about-img-stack">
              <img
                src={HealingWithout}
                alt="Medical team"
                className="abt-img-top"
              />
              <img
                src={Healingabot}
                alt="Clinic"
                className="abt-img-bot"
              />
            </div>

          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="abt-stats-bar">
        <div className="container abt-stats-grid">
          <div className="abt-stat">
            <div className="abt-stat-val">5000+</div>
            <div className="abt-stat-lbl">Patients Treated</div>
          </div>
          <div className="abt-stat">
            <div className="abt-stat-val">15+</div>
            <div className="abt-stat-lbl">Years Experience</div>
          </div>
          <div className="abt-stat">
            <div className="abt-stat-val">98%</div>
            <div className="abt-stat-lbl">Success Rate</div>
          </div>
          <div className="abt-stat">
            <div className="abt-stat-val">50+</div>
            <div className="abt-stat-lbl">Procedures Offered</div>
          </div>
        </div>
      </section>

      {/* ── THREE PILLARS ── */}
      <section className="section">
        <div className="container">
          <div className="abt-section-head">
            <div className="tag-line" style={{ justifyContent: 'center' }}><span>What We Do</span></div>
            <h2 className="sec-title" style={{ textAlign: 'center' }}>
              Three Pillars of <span className="acc">Musculoskeletal Care</span>
            </h2>
          </div>
          <div className="pillar-grid">

            {/* Pain Medicine */}
            <div className="pillar-card">
              <div className="pillar-img">
                <img
                  src={RegenerativeMedicine}
                  alt="Pain Medicine"
                />
                <div className="pillar-img-overlay" style={{ background: 'linear-gradient(to bottom, transparent 40%, #0D4E9Aee)' }} />
                <div className="pillar-icon">🔬</div>
              </div>
              <div className="pillar-body">
                <h3 className="pillar-title">Regenerative Pain Medicine</h3>
                <p className="pillar-desc">Advanced biological therapies — PRP, BMAC, stem cell — to eliminate chronic pain and restore function without major surgery. Especially effective for patients above 45.</p>
                <Link to="/treatments/pain-medicine" className="pillar-link">Learn More →</Link>
              </div>
            </div>

            {/* Orthopaedics */}
            <div className="pillar-card">
              <div className="pillar-img">
                <img
                  src={mainSportsOrthopaedics}
                  alt="Orthopaedics"
                />
                <div className="pillar-img-overlay" style={{ background: 'linear-gradient(to bottom, transparent 40%, #0F6E56ee)' }} />
                <div className="pillar-icon">🦴</div>
              </div>
              <div className="pillar-body">
                <h3 className="pillar-title">Sports Orthopaedics</h3>
                <p className="pillar-desc">Arthroscopic surgery, ligament reconstruction, and regenerative ortho-biologics for athletes and active individuals seeking rapid, lasting recovery.</p>
                <Link to="/treatments/orthopaedics" className="pillar-link">Learn More →</Link>
              </div>
            </div>

            {/* Physiotherapy */}
            <div className="pillar-card">
              <div className="pillar-img">
                <img
                  src={PhysiotherapyRehab}
                  alt="Physiotherapy"
                />
                <div className="pillar-img-overlay" style={{ background: 'linear-gradient(to bottom, transparent 40%, #7C3AEDee)' }} />
                <div className="pillar-icon">💪</div>
              </div>
              <div className="pillar-body">
                <h3 className="pillar-title">Physiotherapy &amp; Rehab</h3>
                <p className="pillar-desc">Structured sports physiotherapy and rehabilitation programs to restore strength, mobility and confidence after injury or surgery.</p>
                <Link to="/treatments/physiotherapy" className="pillar-link">Learn More →</Link>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── DOCTORS ── */}
      <section className="section" style={{ background: '#F8FAFC' }}>
        <div className="container">
          <div className="abt-section-head">
            <div className="tag-line" style={{ justifyContent: 'center' }}><span>Our Team</span></div>
            <h2 className="sec-title" style={{ textAlign: 'center' }}>
              Meet Our <span className="acc">Specialists</span>
            </h2>
          </div>
          <div className="abt-doc-grid">

            {/* Dr Sadhan */}
            <div className="abt-doc-card">
              <div className="abt-doc-img">
                <img
                  src={SadhanPalakuri}
                  alt="Dr. Sadhan Palakuri"
                />
              </div>
              <div className="abt-doc-info">
                <h3 className="abt-doc-name">Dr. Sadhan Palakuri</h3>
                <p className="abt-doc-qual">MBBS, MS.Ortho, FIAS, FIJR, FIPM</p>
                <p className="abt-doc-role">● Consultant Sports Orthopaedics</p>
                <p className="abt-doc-role">● Arthroscopy Knee &amp; Shoulder Specialist</p>
                <p className="abt-doc-role">● Regenerative OrthoBiologist</p>
                <p className="abt-doc-bio">Fellowship-trained sports orthopaedic surgeon combining arthroscopic precision with regenerative orthobiology for athletes.</p>
                <Link to="/doctors" className="abt-doc-btn">Full Profile →</Link>
              </div>
            </div>

            {/* Dr Geetha */}
            <div className="abt-doc-card">
              <div className="abt-doc-img">
                <img
                  src={GeethaBhargavi}
                  alt="Dr. Geetha Bhargavi"
                />
              </div>
              <div className="abt-doc-info">
                <h3 className="abt-doc-name">Dr. Geetha Bhargavi</h3>
                <p className="abt-doc-qual">MBBS, MD.Anaesth, FIPM</p>
                <p className="abt-doc-role">● Consultant Pain Physician</p>
                <p className="abt-doc-role">● Interventional Spine Specialist</p>
                <p className="abt-doc-role">● Regenerative Medicine Expert</p>
                <p className="abt-doc-bio">Fellowship-trained pain physician specializing in PRP, BMAC, and stem cell therapies for chronic pain relief without surgery.</p>
                <Link to="/doctors" className="abt-doc-btn">Full Profile →</Link>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── FACILITIES ── */}
      <section className="section">
        <div className="container">
          <div className="abt-section-head">
            <div className="tag-line" style={{ justifyContent: 'center' }}><span>Our Facilities</span></div>
            <h2 className="sec-title" style={{ textAlign: 'center' }}>
              Modern Facilities <span className="acc">for Better Care</span>
            </h2>
          </div>

          {/* Image grid */}
          <div className="infra-grid">
            <div className="infra-main">
              <img
                src={ModernFacilities}
                alt="Clinic lobby"
              />
            </div>
            <div className="infra-side">
              <div className="infra-side-img">
                <img
                  src={AdvancedTreatment}
                  alt="Medical equipment"
                />
              </div>
              <div className="infra-side-img">
                <img
                  src={PhysioArea}
                  alt="Surgery room"
                />
              </div>
            </div>
          </div>

          {/* Feature badges */}
          <div className="infra-feats">
            <div className="infra-feat">
              <span className="infra-feat-icon">🏥</span>
              <span className="infra-feat-label">Advanced Treatment Rooms</span>
            </div>
            <div className="infra-feat">
              <span className="infra-feat-icon">🔬</span>
              <span className="infra-feat-label">Biologics Lab</span>
            </div>
            <div className="infra-feat">
              <span className="infra-feat-icon">💻</span>
              <span className="infra-feat-label">Imaging Suite</span>
            </div>
            <div className="infra-feat">
              <span className="infra-feat-icon">🏃</span>
              <span className="infra-feat-label">Rehab &amp; Physio Area</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section className="section" style={{ background: '#F8FAFC' }}>
        <div className="container">
          <div className="abt-section-head">
            <div className="tag-line" style={{ justifyContent: 'center' }}><span>Why Choose Us</span></div>
            <h2 className="sec-title" style={{ textAlign: 'center' }}>
              Focused Care. <span className="acc">Proven Results.</span>
            </h2>
          </div>
          <div className="why-grid">
            <div className="why-card">
              <div className="why-icon">🧬</div>
              <h3>Regenerative First</h3>
              <p>We exhaust all biological options before considering surgery.</p>
            </div>
            <div className="why-card">
              <div className="why-icon">🏆</div>
              <h3>Fellowship Trained</h3>
              <p>Both doctors hold international fellowships in their specialties.</p>
            </div>
            <div className="why-card">
              <div className="why-icon">🎯</div>
              <h3>Precision Diagnosis</h3>
              <p>Advanced imaging to pinpoint the exact root cause of your pain.</p>
            </div>
            <div className="why-card">
              <div className="why-icon">⚡</div>
              <h3>Faster Recovery</h3>
              <p>Most patients return to normal activity within weeks, not months.</p>
            </div>
            <div className="why-card">
              <div className="why-icon">🤝</div>
              <h3>Personalised Plans</h3>
              <p>Every treatment plan is custom-built for your condition and goals.</p>
            </div>
            <div className="why-card">
              <div className="why-icon">♻️</div>
              <h3>Integrated Care</h3>
              <p>Pain management, orthopaedics &amp; physio all under one roof.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="abt-cta">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="abt-cta-title">Ready to Experience the TheOrthomed Difference?</h2>
          <p className="abt-cta-sub">Book a consultation with our specialists today.</p>
          <Link to="/contact" className="abt-cta-btn">Book Appointment →</Link>
        </div>
      </section>

    </div>
  );
}